import React from 'react';
import Button from './Button';
import CompetitionTypePill from './CompetitionTypePill';
import CompetitionModePill from './CompetitionModePill';
import CompetitionVisibilityPill from './CompetitionVisibilityPill';
import CompetitionPrizePill from './CompetitionPrizePill';
import { HostedCompetitionSummary } from '../../types/interfaces';
import { formatDate } from '../../utils/dates';

interface HostedCompetitionCardProps {
  competition: HostedCompetitionSummary;
}

const HostedCompetitionCard: React.FC<HostedCompetitionCardProps> = ({ competition }) => {
  const statusClass = (competition.status || 'default').toLowerCase().replace(/\s+/g, '-');
  const formattedEndDate = formatDate(competition.end_date);

  return (
    <div className="joined-card">
      <div className="joined-card__header">
        {competition.logo_path && (
          <img
            src={`${competition.logo_path}`}
            alt={`${competition.title} logo`}
            className="joined-card__logo"
          />
        )}
        <div className="joined-card__title-group">
          <h4>{competition.title}</h4>
          <div className="competition-card__badges">
            <span className={`dashboard__competition-status dashboard__competition-status--${statusClass}`}>
              {competition.status}
            </span>
            <CompetitionTypePill type={competition.type} />
            <CompetitionModePill mode={competition.competition_mode} />
            <CompetitionVisibilityPill visibility={competition.visibility} />
            <CompetitionPrizePill prize={competition.prize} />
          </div>
        </div>
      </div>

      <div className="joined-card__meta">
        <div>
          <span className="joined-card__meta-label">Ends</span>
          <span className="joined-card__meta-value">{formattedEndDate}</span>
        </div>
        <div>
          <span className="joined-card__meta-label">Host Privilege</span>
          <span className="joined-card__meta-value">{competition.privilege}</span>
        </div>
      </div>

      <div className="joined-card__meta-label">
        <Button variant="secondary" size="sm" onClick={() => (window.location.href = `/manage/${competition.id}`)}>
          Manage
        </Button>
      </div>
    </div>
  );
};

export default HostedCompetitionCard;
